import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export interface LoginSession {
  id: string;
  ip_address: string | null;
  city: string | null;
  country: string | null;
  user_agent: string | null;
  logged_in_at: string;
}

export function useLoginSessions(limit = 10) {
  const { user } = useAuth();

  return useQuery<LoginSession[]>({
    queryKey: ['login-sessions', user?.id],
    queryFn: async () => {
      if (!user?.id) return [];

      const { data, error } = await (supabase as any)
        .from('login_sessions')
        .select('id, ip_address, city, country, user_agent, logged_in_at')
        .eq('user_id', user.id)
        .order('logged_in_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return (data as LoginSession[]) ?? [];
    },
    enabled: !!user?.id,
    staleTime: 60_000,
  });
}

// Edge must be checked before Chrome (Edge UA contains "Chrome/")
// Chrome must be checked before Safari (Chrome UA contains "Safari/")
export function parseBrowser(ua: string | null): string {
  if (!ua) return 'Unknown';
  if (ua.includes('Edg/') || ua.includes('Edge/')) return 'Edge';
  if (ua.includes('Chrome/')) return 'Chrome';
  if (ua.includes('Firefox/')) return 'Firefox';
  if (ua.includes('Safari/')) return 'Safari';
  return 'Other';
}
